import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import config from '@/config';
import api from '@/shared/api';
import authService from '@/shared/services/AuthService';
import { CanCreate, CanRead, CanUpdate, CanDelete } from '@/shared/components/security';

import YesNoModal from '@/shared/components/YesNoModal';

import messages from '../taskMessages';
import ToastrService from '@/shared/services/ToastrService';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import LoadingAnimation from '@/shared/components/LoadingAnimation';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { PhoneIcon, NoteIcon, AppointmentIcon, MailIcon } from '@/shared/components/Icons';
import { injectStateService } from '@/shared/services/StateService';
import { states } from '../taskboard/kanban/constants';
import FormattedDateShort from '@/shared/components/FormattedDateShort';

class TaskDetailsInteractions extends PureComponent {
  state = {
    interactions: [],
    deleteInteraction: null,
  };

  componentDidMount() {
    this.retrieveInteractions();
  }
  componentDidUpdate(prevProps) {
    const { taskIds, taskId } = this.props;
    if (
      taskId !== prevProps.taskId ||
      JSON.stringify(prevProps.taskIds) !== JSON.stringify(taskIds)
    ) {
      this.retrieveInteractions();
    }
  }
  retrieveInteractions = () => {
    const { intl, taskIds } = this.props;
    if (!taskIds || taskIds.length === 0) return;
    const linkedInteractions = api.base
      .post(`${config.appUrls.interactions}/api/interactions/interactionlinks`, taskIds)
      .then(
        ({ data: interactions = [] }) => {
          this.setState({ interactions });
        },
        error => {
          handleHttpError(intl)(error);
        },
      );
  };

  deleteInteractionLink = interaction => {
    const { taskIds, taskId } = this.props;
    // if this modal is opened on the main task, the links could also include interaction that are linked to one of the sub tasks
    // when clicking the delete link button, we have to find the correct taskId, in order to delete the link

    let linkId = null;
    if (interaction.links) {
      const tasksLinkedToInteraction = interaction.links
        .filter(x => x.linkType === 1)
        .map(x => x.linkId);
      linkId = taskIds.filter(x => tasksLinkedToInteraction.includes(x))[0];
    } else {
      linkId = taskId;
    }

    api.base
      .delete(`${config.appUrls.interactions}/api/interactions/links/${interaction.id}/${linkId}/1`)
      .then(
        () => {
          this.setState(state => ({
            deleteInteraction: null,
            interactions: state.interactions.filter(x => x.id !== interaction.id),
          }));
        },
        error => {
          const { intl } = this.props;
          handleHttpError(intl)(error);
        },
      );
  };

  renderInteractionIcon = interactionType => {
    const { intl } = this.props;

    switch (interactionType) {
      case 0:
        return <NoteIcon tooltip={intl.formatMessage(messages.Note)} className="margin5R" />;
      case 1:
        return <PhoneIcon tooltip={intl.formatMessage(messages.PhoneCall)} className="margin5R" />;
      case 2:
        return <MailIcon tooltip={intl.formatMessage(messages.Email)} className="margin5R" />;
      case 3:
        return (
          <AppointmentIcon
            tooltip={intl.formatMessage(messages.Appointment)}
            className="margin5R"
          />
        );
      default:
        return <NoteIcon tooltip={intl.formatMessage(messages.Note)} className="margin5R" />;
    }
  };

  render() {
    const { taskId, relationId, intl, disabled, stateService } = this.props;
    const { interactions, deleteInteraction } = this.state;

    if (!interactions || interactions.length === 0) {
      return <></>;
    }

    return (
      <div className="task-detail-section interactions">
        <h5 className="visible-lg-inline-block">{intl.formatMessage(messages.Interactions)}</h5>
        {interactions ? (
          <table>
            <tbody>
              {interactions.map(interaction => (
                <tr key={interaction.id}>
                  <td>
                    <a
                      onClick={() => {
                        stateService.goToInteraction(interaction.relationId, interaction.id);
                      }}
                    >
                      {this.renderInteractionIcon(interaction.interactionType)}
                      {interaction.title} - <FormattedDateShort value={interaction.date} />
                    </a>
                  </td>
                  <td className="actions-column hidden-xs text-right">
                    <div className="btn-group">
                      <CanUpdate on="InteractionsOwn">
                        <i
                          onClick={() => this.setState({ deleteInteraction: interaction })}
                          title={intl.formatMessage(messages.DeleteinteractionLink)}
                          className="fa fa-trash-o clickable margin10L"
                        />
                      </CanUpdate>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <LoadingAnimation />
        )}
        {deleteInteraction ? (
          <YesNoModal
            show={!!deleteInteraction}
            disabled={disabled}
            title={intl.formatMessage(messages.DeleteinteractionLink)}
            message={intl.formatMessage(messages.DeleteInteractionLinkConfirmationMsg)}
            onNo={() =>
              this.setState({
                deleteInteraction: null,
              })
            }
            onSave={() => this.deleteInteractionLink(deleteInteraction)}
          />
        ) : null}
      </div>
    );
  }
}
export default injectStateService(TaskDetailsInteractions);
